import { http } from '@pendo/http';

export async function getPortals () {
    return http
        .get('/api/s/_SID_/vocPortal')
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export async function getPortal (portalId) {
    return http
        .get(`/api/s/_SID_/vocPortal/${portalId}`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export async function createPortal (portal) {
    return http
        .post('/api/s/_SID_/vocPortal', portal)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export async function updatePortal ({ portalId, portal }) {
    return http
        .patch(`/api/s/_SID_/vocPortal/${portalId}`, portal)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export async function findPortalsFromGuideId ({ guideId }) {
    return http
        .get(`/api/s/_SID_/vocPortal/guide/${guideId}`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export async function addPortalToGuide ({ portalId, guideId }) {
    return http
        .put(`/api/s/_SID_/vocPortal/${portalId}/guide/${guideId}`, { headers: { 'Content-Type': 'application/json' } })
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export async function removePortalFromGuide ({ portalId, guideId }) {
    return http
        .delete(`/api/s/_SID_/vocPortal/${portalId}/guide/${guideId}`, {
            headers: { 'Content-Type': 'application/json' },
        })
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function deletePortal (portalId) {
    return http.delete(`/api/s/_SID_/vocPortal/${portalId}`).catch((err) => {
        throw err;
    });
}

export async function duplicatePortal ({ portalId, portal }) {
    return http
        .post(`/api/s/_SID_/vocPortal/${portalId}`, portal)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export async function getPortalIdeas (portalId) {
    return http
        .get(`/api/s/_SID_/vocPortal/${portalId}/items`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function uploadPortalLogo (portalId) {
    return http
        .put(`/api/s/_SID_/vocPortal/${portalId}/upload/logo`, {
            headers: { 'Content-Type': 'application/json' },
        })
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function getPortalState (portalId) {
    return http
        .get(`/api/s/_SID_/vocPortal/${portalId}/state`)
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}

export function getPortalListStates () {
    return http
        .get('/api/s/_SID_/vocPortal/states')
        .then((res) => res.data)
        .catch((err) => {
            throw err;
        });
}
